import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-publish-vote",
  "use": "icon-publish-vote-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-publish-vote\">\n  <line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"13\" />\n  <line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\" />\n  <line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol